export default __webpack_public_path__ + "static/media/dudu_image.41937bba.svg";